export default class HeroScroll {
    constructor($trigger) {
        this.$trigger = $trigger;
        this.$target = document.querySelector($trigger.getAttribute('href'));

        if (!this.$target) {
            return;
        }

        this.$trigger.addEventListener('click', (event) => this.scroll(event));
    }

    scroll(event) {
        event.preventDefault();

        const offset = this.getOffset();
        const top = this.$target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top: Math.max(top, 0),
            behavior: 'smooth',
        });
    }

    getOffset() {
        return window.matchMedia('(max-width: 767px)').matches ? 115 : 220;
    }
}
